
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"7.13 4 15.81 22.45"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.125 8.068h13.807M8.125 21.875h13.807m0-13.807V23.41c0 1.13-.916 2.046-2.046 2.046h-9.715a2.045 2.045 0 01-2.046-2.046V7.045c0-1.13.916-2.045 2.046-2.045h9.715c1.13 0 2.046.916 2.046 2.045v1.023z","stroke":"#fff","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    